import { initialize } from 'redux-form';
import ProgrammationGroups from '../../services/rest/ProgrammationGroups';
import { createRestSlices, applyReducers } from './rest';
import { rememberLastPlaceFromProgrammationsList } from '../../services/programmationPlacePrefs';
import { rememberLastResourcesFromProgrammationsList } from '../../services/programmationResourcePrefs';
import {
    rememberProgrammationCreateDefaultsFromProgrammation,
    build_new_programmation_group_draft,
} from '../../services/programmationCreateOptionsPrefs';

const PROGRAMMATION_GROUP_FORM_NAME = 'programmationGroupForm';

const {
    initialState,
    getReducer, listReducer, updateReducer, duplicateReducer,
    createReducer, deleteReducer, linkedResourcesReducer,
    getAction, listAction, updateAction, duplicateAction,
    createAction, deleteAction, linkedResourcesAction
} = createRestSlices(ProgrammationGroups);

const reducer = (state, action) => {
    switch (action.type) {
        case START_CREATING_PROGRAMMATION_GROUP:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                programmation_groupSuccessfullyDeleted: false,
                programmation_groupSuccessfullyCreated: false,
                programmation_groupSuccessfullyDuplicated: false,
                programmation_group: build_new_programmation_group_draft({
                    pricinglists: action.pricinglists,
                    bucketlists: action.bucketlists,
                    activities: action.activities,
                    users: action.users,
                    instanceId: action.instanceId,
                }),
            };
        case PATCH_CREATE_PROGRAMMATION_GROUP_DRAFT_DEFAULTS: {
            const draft = state.programmation_group;
            if (!draft || draft.id) {
                return state;
            }
            const patch = action.patch || {};
            return {
                ...state,
                programmation_group: {
                    ...draft,
                    ...patch,
                    options: {
                        ...(draft.options || {}),
                        ...(patch.options || {}),
                    },
                },
            };
        }
        case CHANGE_PROGRAMMATION_GROUP:
            return {
                ...state,
                programmation_group: {
                    ...state.programmation_group,
                    ...action.programmation_group
                }
            };
        default:
            return state;
    }
};

/* Export reducer */
export default (state = initialState, action) => {
    return applyReducers(state, action, [
        getReducer, listReducer, updateReducer, duplicateReducer,
        createReducer, deleteReducer, linkedResourcesReducer, reducer
    ]);
}

function instance_id_from_state(getState) {
    const id = getState().auth?.user?.tkt_instance?.id;
    return id != null ? String(id) : 'none';
}

function after_programmation_group_saved(group, getState) {
    const instance_id = instance_id_from_state(getState);
    const programmations = group?.programmations;
    rememberLastPlaceFromProgrammationsList(programmations, instance_id);
    rememberLastResourcesFromProgrammationsList(
        group?.pricinglist_id || group?.bucketlist_id ? [group] : programmations,
        instance_id
    );
    rememberProgrammationCreateDefaultsFromProgrammation(group, instance_id);
}

/* Export CRUD actions */
export const loadProgrammationGroup                = getAction;
export const loadProgrammationGroups               = listAction;
export const deleteProgrammationGroup              = deleteAction;
export const duplicateProgrammationGroup           = duplicateAction;
export const getProgrammationGroupsLinkedResources = linkedResourcesAction;

export function createProgrammationGroup(item, params, callback) {
    return (dispatch, getState) => dispatch(createAction(item, params, (err, created) => {
        if (!err) {
            after_programmation_group_saved(created ?? item, getState);
        }
        callback && callback(err, created);
    }));
}

export function updateProgrammationGroup(item, callback) {
    return (dispatch, getState) => dispatch(updateAction(item, (err, updated) => {
        if (!err) {
            after_programmation_group_saved(item ?? updated, getState);
            if (updated) {
                dispatch(initialize(PROGRAMMATION_GROUP_FORM_NAME, { ...updated }, false));
            }
        }
        callback && callback(err, updated);
    }));
}

const CHANGE_PROGRAMMATION_GROUP = 'kronos/programmation_groups/CHANGE_PROGRAMMATION_GROUP';
export function changeProgrammationGroup(programmation_group) {
    return (dispatch) => {
        return dispatch({ type: CHANGE_PROGRAMMATION_GROUP, programmation_group });
    };
}
const START_CREATING_PROGRAMMATION_GROUP = 'kronos/programmation_groups/START_CREATING_PROGRAMMATION_GROUP';
const PATCH_CREATE_PROGRAMMATION_GROUP_DRAFT_DEFAULTS =
    'kronos/programmation_groups/PATCH_CREATE_PROGRAMMATION_GROUP_DRAFT_DEFAULTS';

/**
 * @param {{
 *   bucketlists?: Array,
 *   pricinglists?: Array,
 *   activities?: Array,
 *   users?: Array,
 *   instanceId?: string|null,
 * }} [params]
 */
export function startCreateProgrammationGroup(params = {}) {
    const legacy_bucketlists = Array.isArray(params) ? params : undefined;
    return {
        type: START_CREATING_PROGRAMMATION_GROUP,
        bucketlists: legacy_bucketlists ?? params.bucketlists,
        pricinglists: params.pricinglists,
        activities: params.activities,
        users: params.users,
        instanceId: params.instanceId,
    };
}

export function patchCreateProgrammationGroupDraftDefaults(patch) {
    return { type: PATCH_CREATE_PROGRAMMATION_GROUP_DRAFT_DEFAULTS, patch };
}
